module.exports = __webpack_public_path__ + "media/images/lb/671-1833478741b2a39a9ca3a7cded136534.svg";